import { render, staticRenderFns } from "./TabContent.vue?vue&type=template&id=62eeb0c0&"
import script from "./TabContent.vue?vue&type=script&lang=ts&"
export * from "./TabContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports